
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suggest-a-location",
      function () {
        return require("private-next-pages/suggest-a-location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suggest-a-location"])
      });
    }
  